import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../../../constants/constants';
import useNRQuery from '../../../../graphql/useNRQuery';
import { GET_JIRA_INTEGRATION } from '../../../../graphql/queries/jiraIntegration';
import { JIRA_INTEGRATION_STATUS } from './jiraIntegration.constants';

function useIsJiraIntegrationActive() {
  const { value: isJiraIntegrationEnabled } = useFlag(FEATURE_FLAGS.SETTINGS_JIRA_INTEGRATION, false);

  const [jiraIntegration, isLoading] = useNRQuery({
    query: GET_JIRA_INTEGRATION,
    options: { skip: !isJiraIntegrationEnabled },
    qlObjKey: 'jiraIntegration',
    defaultValue: null
  });

  const isJiraIntegrationActive = isJiraIntegrationEnabled && jiraIntegration?.status === JIRA_INTEGRATION_STATUS.CONNECTED;

  return {
    isJiraIntegrationActive,
    isJiraIntegrationLoading: isJiraIntegrationEnabled && isLoading
  };
}

export default useIsJiraIntegrationActive;
